module.exports = __webpack_public_path__ + "img/cadeado.8a656b3d.svg";